/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Closed_NoticeInputs */

const en_company_registration_closed_notice = /** @type {(inputs: Company_Registration_Closed_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company registration is currently closed. New company registrations cannot be submitted.`)
};

const de_company_registration_closed_notice = /** @type {(inputs: Company_Registration_Closed_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anmeldung für Unternehmen ist derzeit geschlossen. Neue Unternehmensregistrierungen können nicht eingereicht werden.`)
};

/**
* | output |
* | --- |
* | "Company registration is currently closed. New company registrations cannot be submitted." |
*
* @param {Company_Registration_Closed_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_closed_notice = /** @type {((inputs?: Company_Registration_Closed_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Closed_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_closed_notice(inputs)
	return en_company_registration_closed_notice(inputs)
});